import React, { Component } from 'react'
import { connect } from 'react-redux'

import HelmetHead from '../utils/HelmetHead'

class CustomerLanding extends Component {
    render() {
        const { site = '' } = this.props

        return (
            <div>
                <HelmetHead title="Customer" />

                <h1>Customer Account</h1>

                <div>Welcome to your <strong>{!!site && site.title}</strong> account!</div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        site: state.siteInfo.site
    }
}

export default connect(mapStateToProps)(CustomerLanding)



// WEBPACK FOOTER //
// ./src/components/customer/CustomerLanding.js